export default "Female_25_Ceylon_1.png\nFemale_25_Ceylon_2.png\n";